import { inject, Injectable } from '@angular/core';
import { SettingsService } from '../interface/settings-service';
import { ObjectFactory } from '../engine/http/factory/object-factory';
import { HttpErrorResponse } from '@angular/common/http';
import { RestService } from '../engine/http/rest.service';
import { RestError } from '../model/rest-error';

@Injectable({
  providedIn: 'root',
})
export class ServerSettingsService extends SettingsService {
  protected rest = inject(RestService);

  public tm: any;
  public lock = false;

  addSetting(name: string, value: any) {
    this.settings[name] = value;
    this.save();
  }

  clear() {
    this.lock = false;
    this.settings = {};
  }

  /**
   * @deprecated
   * Old clear method
   */
  clearAndSendToServer(): void {
    this.clear();
    const uri = `${this.rest.config.settingsApi}/${this.getSettingsKey()}`;
    this.rest.delete(uri).subscribe({
      next: () => {
        console.warn('Settings was cleared');
      },
    });
  }

  reset() {
    this.settings = { lastDateReset: new Date().getTime() };
    this.save(true);
    this.obs.next(this.settings);
  }

  getAuthorization(crud: string[]): boolean {
    void crud;
    return false;
  }

  getSetting(name: string) {
    if (this.settings) {
      return this.settings[name];
    }
  }

  getSettingsKey(): string {
    return `${this.rest.config.appId}`;
  }

  load(force?: boolean) {
    if (this.lock) {
      return;
    }
    if (!this.settings || Object.keys(this.settings).length === 0 || force) {
      this.lock = true;
      const uri = this.rest.config.settingsApi;
      this.rest
        .getById(new ObjectFactory(uri), this.getSettingsKey(), {
          isSilent: true,
        })
        .subscribe({
          next: (settings) => {
            if (!settings) {
              this.loadDefault();
              this.save();
            } else {
              this.settings = settings;
            }
            this.obs.next(this.settings);
            this.lock = false;
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 404) {
              this.save();
              this.obs.next(this.settings);
            } else {
              const returnError = new RestError(error);
              returnError.source = 'get';
              this.rest.restErrorE.emit(returnError);
            }
            this.lock = false;
          },
        });
    }
  }

  protected loadDefault() {
    const params = localStorage.getItem('default-setting');
    if (params) {
      this.settings = JSON.parse(params);
    }
  }

  save(force?: boolean) {
    if (!this.settings) {
      this.settings = {};
    }
    if (force) {
      this._sendSettingsToServer();
      return;
    }
    if (!this.tm) {
      this.tm = setTimeout(() => {
        this._sendSettingsToServer();
      }, 5000);
    }
  }

  private _sendSettingsToServer(): void {
    const uri = `${this.rest.config.settingsApi}/${this.getSettingsKey()}`;
    if (Object.keys(this.settings).length !== 0) {
      this.rest
        .put(uri, this.settings, { showLoading: false })
        .subscribe(() => {
          localStorage.setItem(
            this.getSettingsKey(),
            JSON.stringify(this.settings),
          );
          this.tm = null;
        });
    } else {
      this.tm = null;
    }
  }
}
